import {Injectable} from "@angular/core";
import {MatLegacyDialog as MatDialog} from "@angular/material/legacy-dialog";
import { CtWebapiService, DataRequest, MethodEnum, CtWebapiGenericResponse } from '@ctsolution/ct-webapi';
import { Observable } from 'rxjs';
import {WorkOrderDocumentsWizardComponent} from "./work-order-documents-wizard/work-order-documents-wizard.component";
import {WorkOrderDocumentsConfiguration} from "./work-order-documents.configuration";
import { FileOriginEnum } from "projects/ct-manager/src/app/_core/services/note-services/note-dialog.configuration";

/**
 * Interface per i parametri di cancellazione documento
 */
export interface DeleteDocumentParams {
  oid: number;
  fileOrigin: FileOriginEnum;
  deleteFromFileSystem: boolean;
}
@Injectable()
export class WorkOrderDocumentsService {

  constructor(
    private dialog: MatDialog, 
    private webapiService: CtWebapiService
  ) {
  }

  /**
   * Apre il wizard per l'upload/modifica documenti
   */
  open(parameter: WorkOrderDocumentsConfiguration | null) {

    return this.dialog
      .open(WorkOrderDocumentsWizardComponent, {
        data: parameter,
        maxWidth: 500,
        panelClass: 'work-order-file-upload-container'
      });

  }

  /**
   * Elimina un documento tramite chiamata API custom
   * Gestisce diversi tipi di FileOrigin (WorkOrderFile, UserWorkingHoursFile, LeadFile)
   * 
   * @param params - Parametri per la cancellazione del documento
   * @returns Observable con la risposta dell'API
   */
  deleteDocument(params: DeleteDocumentParams): Observable<CtWebapiGenericResponse<any>> {
    
    // Validazione input
    if (!params || !params.oid || !params.fileOrigin) {
      throw new Error('WorkOrderDocumentsService.deleteDocument: parametri non validi');
    }

    // Determinazione dell'endpoint basata sul FileOrigin
    let deleteEndpoint = '';
  
    switch (params.fileOrigin) {
      case FileOriginEnum.WorkingHour:
        deleteEndpoint = `/UserWorkingHoursFile/DeleteByOid/${params.oid}`;
        break;
      case FileOriginEnum.Lead:
        deleteEndpoint = `/LeadFile/DeleteByOid/${params.oid}`;
        break;
      case FileOriginEnum.WorkOrder:
      default:
        deleteEndpoint = `/WorkOrderFile/DeleteByOid/${params.oid}`;
        break;
    }

    // Aggiunta del parametro per la cancellazione dal file system
    deleteEndpoint += `?deleteFileFromFileSystem=${params.deleteFromFileSystem}`;

    // Costruzione della richiesta DELETE
    const request = DataRequest
      .create()
      .setUrl(deleteEndpoint)
      .setMethod(MethodEnum.DELETE);

    // Esecuzione della chiamata API
    return this.webapiService.delete<any>(request);
  }

}
